
const domainUsername = process.env.REACT_APP_DOMAIN_USERNAME;
const domainPassword = process.env.REACT_APP_DOMAIN_PASSWORD;
const basicUrl = process.env.REACT_APP_BASIC_URL;

const dbUser = process.env.REACT_APP_DB_USER;
const dbPassword = process.env.REACT_APP_DB_PASSWORD;
const dbHost = process.env.REACT_APP_DB_HOST;
const dbName = process.env.REACT_APP_DB_NAME;

const dbNameLiferay = process.env.REACT_APP_DB_NAME_LIFERAY;


const dbConfig = {
    user: `${dbUser}`,
    password: `${dbPassword}`,
    server: `${dbHost}`, // You can use 'localhost\\instance' to connect to named instance
    database: `${dbName}`,
    options: {
      // encrypt: true, // for azure only
      trustServerCertificate: true // set to true for local dev or self-signed certs, otherwise set to false
    }
  }

  const dbConfigLiferay = {
    user: `${dbUser}`,
    password: `${dbPassword}`,
    server: `${dbHost}`, // You can use 'localhost\\instance' to connect to named instance
    database: `${dbNameLiferay}`,
    options: {
      // encrypt: true, // for azure only
      trustServerCertificate: true // set to true for local dev or self-signed certs, otherwise set to false
    }
  }


export { basicUrl, domainUsername, domainPassword, dbConfig, dbConfigLiferay };